import type { ReactNode } from 'react';

import { Breadcrumbs } from '~/chords';
import { Icon } from '~/components';

export interface BreadcrumbItem {
  to?: string;
  label: ReactNode;
  iconType?: string;
}

interface BreadcrumbListProps {
  breadcrumbItems: BreadcrumbItem[];
}

export function BreadcrumbList({ breadcrumbItems }: BreadcrumbListProps) {
  return (
    <Breadcrumbs.Root>
      {breadcrumbItems.map((item, index) => (
        <Breadcrumbs.Item key={`${item.to}-${index}`} to={item.to}>
          {item.iconType ? (
            <Icon
              type={item.iconType}
              size="sm"
              variant="regular"
              className="mr-sm"
            />
          ) : null}
          {item.label}
        </Breadcrumbs.Item>
      ))}
    </Breadcrumbs.Root>
  );
}

BreadcrumbList.displayName = 'BreadcrumbList';
